"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentedControl = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_spacer_1 = require("@travelnest/merlin.spacer");
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const React = __importStar(require("react"));
const react_swipeable_views_react_18_fix_1 = __importDefault(require("react-swipeable-views-react-18-fix"));
const Titles = styled_1.default.div `
	width: 100%;
	display: flex;
	justify-content: space-evenly;
	margin-bottom: 15px;
	position: relative;
	@media only screen and (min-width: 768px) {
		max-width: 515px;
	}
`;
const ActiveHighlight = styled_1.default.div `
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 11px;
  transition: left 400ms, right 400ms;
  border-radius: 20px;
  background: radial-gradient(85.2% 85.2% at 13.92% 14.8%, ${merlin_theme_1.default.paletteV5.pink.primary} 17.71%, ${merlin_theme_1.default.paletteV5.purple.primary} 100%);
  height: 4px;
`;
const SegmentHeading = styled_1.default.div `
	${merlin_theme_1.default.typographyV5.micro};
	${({ active }) => `color: ${active ? merlin_theme_1.default.colours.neutral.darkest : merlin_theme_1.default.colours.neutral.dark}`};
	text-align: center;
	width: 100%;
	position: relative;
	cursor: pointer;

	&:focus {
		outline: none;
	}
	&:before {
		content: '';
		display: block;
		position: absolute;
		top: -2px;
		bottom: -2px;
		right: -2px;
		left: -2px;
		border-radius: calc(2px + ${merlin_theme_1.default.layout.radius.squared});
		border: 1px solid ${merlin_theme_1.default.paletteV5.pink.primary};
		opacity: 0;
		transition: opacity ${merlin_theme_1.default.motion.transition.default};
		-webkit-transition: opacity ${merlin_theme_1.default.motion.transition.default};
		pointer-events: none;
	}
	&:focus:before,
	&:active:before {
		opacity: 1;
	}

	@media only screen and (min-width: 768px) {
		&:hover {
		${({ active }) => !active && `
			&:after {
				content: '';
				display: block;
				position: absolute;
				width: 100%;
				margin-top: 11px;
				background: ${merlin_theme_1.default.paletteV5.purple.primary};
				opacity: 50%;
				height: 4px;
				border-radius: 20px;
			}
		`};
	}
	}
`;
/*
all animation logic is taken from
https://medium.com/@f.bagnardi/creating-an-animated-tabs-component-with-react-js-94448334e206
How does this work?
the component takes an arbritary number of segments and renders their titles, using the callback ref method will also
append the DOM node into a _segmentsRef_ variable.
the container they sit in also has a ref and this ref along side the ref of the currently active tab is used to calc
the the absolute positioning of the ActiveHighlight element.
Due to its absolute positioning we also need to add a resize event listening so that if the viewport changes we can
recalc where it should sit and how wide it is.
*/
const SegmentedControl = ({ id, segments, activeSegment, handleViewChange }) => {
    const segmentsRef = React.useRef([]);
    const segmentContainerRef = React.useRef(null);
    const [currentSegmentSizes, setCurrentSegmentSizes] = React.useState({});
    const [currentWindowSize, setCurrentWindowSize] = React.useState(window.innerWidth);
    React.useEffect(() => {
        window.addEventListener('resize', () => setTimeout(() => setCurrentWindowSize(window.innerWidth), 1));
    }, []);
    React.useEffect(() => {
        var _a;
        if (segmentContainerRef.current) {
            const segmentContainer = (_a = segmentContainerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            const segmentSizes = {};
            segmentsRef.current.map((segment) => {
                var _a;
                if (segment.element) {
                    const bounds = (_a = segment.element) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                    const left = bounds.left - segmentContainer.left;
                    const right = segmentContainer.right - bounds.right;
                    segmentSizes[segment.id] = { left: `${left}px`, right: `${right}px` };
                }
            });
            setCurrentSegmentSizes(segmentSizes);
        }
    }, [activeSegment, currentWindowSize]);
    return (React.createElement("div", { "data-testid": `segmented-control-${id}` },
        React.createElement(merlin_spacer_1.MarginWrapper, null,
            React.createElement(Titles, { ref: segmentContainerRef },
                segments.map((s, idx) => (React.createElement(SegmentHeading, { key: `segment-heading-${s.id}-${idx}`, tabIndex: 0, "data-testid": `segment-heading-${s.id}`, role: "button", "aria-label": `segment-heading-${s.ariaLabel}`, ref: (el) => segmentsRef.current[idx] = { id: s.id, element: el }, onClick: () => {
                        var _a;
                        if (s.onSegmentClick) {
                            s.onSegmentClick(s);
                        }
                        handleViewChange(idx);
                        (_a = segmentsRef.current[idx].element) === null || _a === void 0 ? void 0 : _a.blur();
                    }, onKeyPress: (event) => {
                        var _a;
                        if (event.key === 'Enter') {
                            if (s.onSegmentClick) {
                                s.onSegmentClick(s);
                            }
                            handleViewChange(idx);
                            (_a = segmentsRef.current[idx].element) === null || _a === void 0 ? void 0 : _a.blur();
                        }
                    }, active: s.id === segments[activeSegment].id }, s.title))),
                React.createElement(ActiveHighlight, { style: currentSegmentSizes[segments[activeSegment].id] }))),
        React.createElement(merlin_spacer_1.HorizontalRule, { style: { background: merlin_theme_1.default.colours.neutral.medium } }),
        React.createElement(merlin_spacer_1.MarginWrapper, null,
            React.createElement(react_swipeable_views_react_18_fix_1.default, { index: activeSegment, onChangeIndex: (index) => {
                    handleViewChange(index);
                    if (segments[index]) {
                        const newSegment = segments[index];
                        if (newSegment.onSegmentClick !== undefined) {
                            newSegment.onSegmentClick(segments[index]);
                        }
                    }
                } }, segments.map((s) => s.view)))));
};
exports.SegmentedControl = SegmentedControl;
//# sourceMappingURL=SegmentedControl.js.map